<template>
  <portal to="modal">
    <ontick-modal
      size="custom"
      customSizeClass="w-full sm:w-[600px] lg:w-[800px]"
      :open="show"
      :showCloseButton="false"
      @close="$emit('close', !show)"
    >
      <div v-if="type === 'go_to_xp'" class="flex h-full w-full flex-col justify-center space-y-4">
        <div class="space-y-2">
          <h3 class="text-left text-xl font-bold">Upgrade necessário</h3>
          <p class="text-sm">
            Veja no tutorial abaixo como ativar um dos planos da OnTick Invest através da sua conta XP.
          </p>
        </div>
        <div style="padding: 56.25% 0 0 0; position: relative" class="h-full w-full">
          <iframe
            src="https://player.vimeo.com/video/803425329?h=292ad85756&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
            title="Como ativar plano XP"
          ></iframe>
        </div>
        <div class="flex w-full items-center justify-center">
          <a
            class="bg-ontick-blue-900 flex items-center justify-center space-x-2 rounded px-6 py-4 text-sm font-semibold text-white shadow-lg filter transition-all hover:brightness-125"
            href="https://www.xpi.com.br/"
            target="_blank"
          >
            <span> Ir para XPI.com.br </span>
            <i v-html="$icons.open_in_new"></i>
          </a>
        </div>
      </div>
      <div
        v-else
        class="divide-ontick-carbon-200 dark:divide-ontick-steel-500 flex flex-col items-center justify-center divide-y-2"
      >
        <div class="flex flex-col items-center space-y-4 py-6 md:flex-row md:space-x-6 md:space-y-0">
          <img src="/img/pana.svg" alt="Upgrade necessário" />
          <div class="flex flex-col space-y-4">
            <h2 class="text-ontick-carbon-900 text-2xl font-bold uppercase dark:text-gray-300 md:text-4xl">
              Upgrade necessário
            </h2>
            <div class="flex flex-col space-y-2">
              <div class="flex items-center space-x-2">
                <h3 class="text-ontick-carbon-900 text-lg font-semibold dark:text-gray-300">
                  {{ modalText.title }}
                </h3>
                <ontick-plan-logo-component
                  v-if="type === 'extension_unavailable_for_plan' || type === 'strategy_unavailable_for_plan'"
                  :plan="productPlan"
                />
              </div>
              <p
                class="text-gray-500 dark:text-gray-400"
                v-if="type === 'extension_unavailable_for_plan' || type === 'strategy_unavailable_for_plan'"
              >
                A
                {{ type === "extension_unavailable_for_plan" ? "extensão" : "estratégia" }}
                <template v-if="productPlan">
                  <span class="font-bold">{{ productName }}</span> é exclusiva para usuários
                  <span class="font-bold">{{ this.productPlan.replace("_", " ").split(" ")[0] }}</span>
                </template>
                <template v-else>
                  <span class="font-bold">{{ productName }}</span> não está disponível para o seu plano atual
                </template>
                . Faça agora mesmo o upgrade e adicione esta
                {{ type === "extension_unavailable_for_plan" ? "extensão" : "estratégia" }}!
              </p>
              <p class="text-gray-500 dark:text-gray-400" v-else>
                {{ modalText.text }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex w-full items-center justify-center py-6">
          <ontick-button @click.native="$router.push('/account?tag=plans')">
            <div class="flex items-center justify-center space-x-2">
              <i v-html="$icons.plans"></i>
              <span> Conheça nossos planos </span>
            </div>
          </ontick-button>
        </div>
      </div>
    </ontick-modal>
  </portal>
</template>

<script>
import ontickPlanLogoComponent from "./ontick-plan-logo.component.vue";

export default {
  components: { ontickPlanLogoComponent },
  props: {
    show: {
      type: Boolean,
    },
    type: {
      type: String,
      validator: (val) => {
        return [
          "running_limit",
          "capital_limit",
          "volume_limit",
          "extension_unavailable_for_plan",
          "strategy_unavailable_for_plan",
          "go_to_xp",
        ].includes(val);
      },
    },
    productName: {
      type: String,
    },
    productPlan: {
      type: String,
    },
  },

  model: {
    prop: "show",
    event: "close",
  },

  computed: {
    modalText() {
      const types = {
        running_limit: {
          text: "Você atingiu o limite máximo de estratégias ativas para o seu plano. Para iniciar mais estratégias, faça o upgrade para um novo plano.",
          title: "Limite de investimentos atingido",
        },
        capital_limit: {
          text: "Você atingiu o limite máximo de capital alocado para o seu plano. Para realizar mais investimentos, faça o upgrade para um novo plano.",
          title: "Limite financeiro atingido",
        },
        volume_limit: {
          text: "Você atingiu o limite máximo de contratos para o seu plano. Para alocar mais contratos, faça o upgrade para um novo plano.",
          title: "Limite de contratos atingido",
        },
        extension_unavailable_for_plan: {
          title: "Extensão OnTick",
        },
        strategy_unavailable_for_plan: {
          title: "Estratégia OnTick",
        },
        default: {
          text: "Você precisa de um upgrade de plano para executar esta ação.",
          title: "Faça um upgrade",
        },
      };

      return types[this.type] || types.default;
    },
    isXpPage() {
      return this.$route.name === "Analistas XP";
    },
  },
};
</script>

<style></style>
